import React from 'react';
import IGKeywordSlideoutBannerNormalSrc from './IGKeywordSlideoutBanner_normal.png';
import IGKeywordSlideoutBannerWhiteSrc from './IGKeywordSlideoutBanner_white.png';

export const IGKeywordSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={IGKeywordSlideoutBannerWhiteSrc} />
  ) : (
    <img src={IGKeywordSlideoutBannerNormalSrc} />
  );
};
